module.exports = __webpack_public_path__ + "89c5d729127f345ceabcdf83b949f69a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-14.png
// module id = 482
// module chunks = 0